import { Box } from '@dixa/lib-shared-habla';
import { Country } from 'lib-shared-legacy-types';

interface PropsT {
  countryISOSelected: Country['iso'];
  countryCodeSelected: Country['phone'];
}

export const CountryCodeSelected = ({
  countryISOSelected,
  countryCodeSelected,
}: PropsT) => (
  <Box
    as="span"
    padding="100"
    className="flags"
    style={{ display: 'flex', flexDirection: 'row' }}
  >
    <Box as="span" className={`flag ${countryISOSelected}`}></Box>
    <Box as="span" margin="0 0 0 400" style={{ whiteSpace: 'nowrap' }}>
      {countryCodeSelected}
    </Box>
  </Box>
);
